import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import Button from '../../components/common/button';
import { Titlespan, Description } from '../../components/common/title/index';
import Image from '../../components/common/image/index';
import BannerBackgroundImages from '../../data/bannerimages';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import './banner.scss';

const Shape2 = '/assets/images/banner/bg-wave.svg';
const Shape3 = '/assets/images/banner/wave.png';
const BannerImg1 = '/assets/images/banner/bannerimg.png';

function Banner(props) {
  return (
    <section className={`banner-wrapper ${props.ChangeClass}`} id="home">
      <div className="banner-outer">
        <div className="slider-animation-images">
          {BannerBackgroundImages.map((img, index) => (
            <span className={`image${index + 1}`} key={`banner-${index}`}><Image Path={img.img} /></span>
          ))}
        </div>
        <Container>
          <Row>
            <Col md={6}>
              <div className="banner-content">
                <Titlespan
                  Class="banner-main-title"
                  Label="Educational Tools"
                  Name="For All Lessons"
                />
                <Description
                  Class="banner-dec"
                  Name="Used by over 2,500 teachers and students, Smart Board Learning utilizes music, videos, and games/quizzes, that correlate with State Standards of Learning, NGSS Standards, and Common Core Standards. With customizable tools, Smart Board Learning works closely with educators and parents to insure the best tools for kids. Explore the links below to preview specific tools."
                />
                <div className="banner-btn-wrapper">
                  <AnchorLink
                    href="#preview"
                    offset={() => (window.innerWidth < 768 ? 100 : 70)}
                  >
                    <Button
                      Class="button1 button3 btn"
                      Name="LEARN MORE"
                    />
                  </AnchorLink>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="banner-image">
                <Image
                  Path={BannerImg1}
                  Class="banner-img"
                />
              </div>
            </Col>
          </Row>
        </Container>

        {(props.ChangeClass === 'demo2' || props.ChangeClass === 'demo3') &&
          <div className="bottom-img">
            {props.ChangeClass === 'demo2' ?
              <Image Path={Shape2} /> :
              <Image Path={Shape3} />
            }
          </div>
        }
      </div>
    </section>
  );
}

export default Banner;
